import { IVideoItem } from "@kehe/phoenix-video-player";
import { HelpCenterGroup } from "../modules/reporting/models/enum/help-center-group";
export class ExternalVideo implements IVideoItem {
  constructor(
    public title: string,
    public vimeoId: string,
    public group?: HelpCenterGroup,
    public backgroundUrl?: string,
  ) {}
}
